import apiMixin from "../../../mixins/apiMixin";

const Plan = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {

        deactivateplan: function (state, payload) {
            try {

                return apiMixin.methods.deactivateuserplan(payload).then(
                    response => {
                        if (!response) {
                            return false;
                        }
                        if (response.status === 200) {

                            // console.log(response.data.result);
                            return true;
                        }
                    }
                )
            } catch (e) {
                console.log(e);
            }
        },

        updateUserPlanSearchCount: function (state, payload) {
            try {

                return apiMixin.methods.updateUserPlanSearchCount(payload).then(
                    response => {
                        if (!response) {
                            return false;
                        }
                        if (response.status === 200) {

                            // console.log(response.data.result);
                            return true;
                        }
                    }
                )
            } catch (e) {
                console.log(e);
            }
        },
        //

    },
    getters: {},
}
export default Plan
